// extracted by mini-css-extract-plugin
export var divider = "_qg-0";
export var systemMessage = "_qg-1";